

class ActivityValidator {
    constructor() {
        this.keys = [
            'wms_activity_key_2024',
            'ecargo_session_salt',
            'activity_validator_v1'
        ]
        

        this.timeTolerance = 5000
        

        this.signatureCache = new Map()
        this.cacheMaxSize = 50
    }


    simpleHash(str) {
        let hash = 0
        if (str.length === 0) return hash
        
        for (let i = 0; i < str.length; i++) {
            const char = str.charCodeAt(i)
            hash = ((hash << 5) - hash) + char
            hash = hash & hash
        }
        return Math.abs(hash)
    }


    generateSignature(timestamp, username = '') {
        const cacheKey = `${timestamp}_${username}`
        if (this.signatureCache.has(cacheKey)) {
            return this.signatureCache.get(cacheKey)
        }


        const baseString = `${timestamp}_${username}_${this.keys.join('_')}`
        

        let signature = this.simpleHash(baseString).toString(36)
        

        const timeCheck = (timestamp % 10000).toString(36)
        signature = `${signature}_${timeCheck}`
        

        if (this.signatureCache.size >= this.cacheMaxSize) {

            const firstKey = this.signatureCache.keys().next().value
            this.signatureCache.delete(firstKey)
        }
        this.signatureCache.set(cacheKey, signature)
        
        return signature
    }


    validateSignature(timestamp, signature, username = '') {
        if (!timestamp || !signature) {
            return false
        }


        const expectedSignature = this.generateSignature(timestamp, username)
        

        if (signature !== expectedSignature) {
            return false
        }


        const now = Date.now()
        const timeDiff = Math.abs(now - timestamp)
        

        const maxAge = 24 * 60 * 60 * 1000
        if (timeDiff > maxAge && timestamp < now) {
            return false
        }
        
        if (timestamp > now + this.timeTolerance) {
            return false
        }

        return true
    }


    createSecureActivityData(timestamp, username = '') {
        const signature = this.generateSignature(timestamp, username)
        return {
            timestamp: timestamp,
            signature: signature,
            created: Date.now()
        }
    }


    validateActivityData(activityData, username = '') {
        if (!activityData || typeof activityData !== 'object') {
            return false
        }

        const { timestamp, signature, created } = activityData
        
        if (!timestamp || !signature) {
            return false
        }


        if (!this.validateSignature(timestamp, signature, username)) {
            return false
        }


        if (created) {
            const now = Date.now()
            const createdDiff = Math.abs(now - created)
            const maxCreatedAge = 25 * 60 * 60 * 1000
            
            if (createdDiff > maxCreatedAge && created < now) {
                return false
            }
        }

        return true
    }


    parseStoredData(storedData) {
        if (!storedData) {
            return null
        }

        try {
            const parsed = JSON.parse(storedData)
            return parsed
        } catch (error) {

            const timestamp = parseInt(storedData)
            if (!isNaN(timestamp) && timestamp > 0) {

                return {
                    timestamp: timestamp,
                    signature: null,
                    created: Date.now(),
                    legacy: true
                }
            }
            return null
        }
    }


    clearCache() {
        this.signatureCache.clear()
    }
}

export default new ActivityValidator()